module.exports = [
 {
  "start": 41,
  "end": 3875,
  "text": "Mutaflor is a silent work from '96 that propose"
 },
 {
  "start": 4041,
  "end": 6500,
  "text": "a reversing the power structure. "
 },
 {
  "start": 6625,
  "end": 10291,
  "text": "Here for once the work is consuming the spectator."
 },
 {
  "start": 10375,
  "end": 13500,
  "text": "This video projection onto the floor also refers to "
 },
 {
  "start": 13625,
  "end": 18041,
  "text": "the parallelism of digesting impressions to digesting food. "
 },
 {
  "start": 18208,
  "end": 21291,
  "text": "Our body and mind is deciding unconsciously "
 },
 {
  "start": 21375,
  "end": 23333,
  "text": "what we need and want to keep, "
 },
 {
  "start": 23500,
  "end": 27083,
  "text": "process and what we have to let go out again."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room3/audio1/03_1MCA-Mutoflor.js